const satoshiFontFamily = '"Satoshi", -apple-system, sans-serif';
const fontFamily = '"Inter", -apple-system, sans-serif';
const Typography = {
    fontFamily,
    fontSize: 16,
    htmlFontSize: 16,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    display2xl: {
        fontFamily: satoshiFontFamily,
        fontSize: "4.5rem",
        fontWeight: 500,
        fontFeatureSettings: "'tnum' 1",
        lineHeight: "5.5rem"
    },
    displayXl: {
        fontFamily: satoshiFontFamily,
        fontSize: "3.75rem",
        fontWeight: 500,
        fontFeatureSettings: "'tnum' 1",
        lineHeight: "4.5rem"
    },
    displayLg: {
        fontFamily: satoshiFontFamily,
        fontSize: "3rem",
        fontWeight: 500,
        fontFeatureSettings: "'tnum' 1",
        lineHeight: "3.75rem"
    },
    displayMd: {
        fontFamily: satoshiFontFamily,
        fontSize: "2.25rem",
        fontWeight: 500,
        fontFeatureSettings: "'tnum' 1",
        lineHeight: "2.75rem"
    },
    displaySm: {
        fontFamily: satoshiFontFamily,
        fontSize: "1.875rem",
        fontWeight: 500,
        fontFeatureSettings: "'tnum' 1",
        lineHeight: "2.375rem"
    },
    displayXs: {
        fontFamily: satoshiFontFamily,
        fontSize: "1.5rem",
        fontWeight: 500,
        fontFeatureSettings: "'tnum' 1",
        lineHeight: "2rem"
    },
    textXl: {
        fontFamily: satoshiFontFamily,
        fontSize: "1.25rem",
        lineHeight: "1.875rem",
        fontFeatureSettings: "'tnum' 1"
    },
    textLg: {
        fontFamily: satoshiFontFamily,
        fontSize: "1.125rem",
        lineHeight: "1.75rem",
        fontFeatureSettings: "'tnum' 1"
    },
    textMd: {
        fontFamily: satoshiFontFamily,
        fontSize: "1rem",
        lineHeight: "1.5rem",
        fontFeatureSettings: "'tnum' 1"
    },
    textSm: {
        fontFamily,
        fontSize: "0.875rem",
        lineHeight: "1.25rem",
        fontFeatureSettings: "'tnum' 1"
    },
    textXs: {
        fontFamily,
        fontSize: "0.75rem",
        lineHeight: "1rem",
        fontFeatureSettings: "'tnum' 1"
    },
    text2xs: {
        fontFamily,
        fontSize: "0.625rem",
        lineHeight: "1rem",
        fontFeatureSettings: "'tnum' 1"
    },
    // [LEGACY]
    h1: {
        fontFamily: satoshiFontFamily,
        fontSize: "4.5rem",
        lineHeight: "5.5rem",
        fontFeatureSettings: "'tnum' 1"
    },
    h2: {
        fontFamily: satoshiFontFamily,
        fontSize: "3.75rem",
        lineHeight: "4.5rem",
        fontFeatureSettings: "'tnum' 1"
    },
    h3: {
        fontFamily: satoshiFontFamily,
        fontSize: "3rem",
        lineHeight: "3.75rem",
        fontFeatureSettings: "'tnum' 1"
    },
    h4: {
        fontFamily: satoshiFontFamily,
        fontSize: "2.25rem",
        lineHeight: "2.75rem",
        fontFeatureSettings: "'tnum' 1"
    },
    h5: {
        fontFamily: satoshiFontFamily,
        fontSize: "1.875rem",
        lineHeight: "2.375rem",
        fontFeatureSettings: "'tnum' 1"
    },
    h6: {
        fontFamily: satoshiFontFamily,
        fontSize: "1.5rem",
        lineHeight: "2rem",
        fontFeatureSettings: "'tnum' 1"
    },
    body1: {
        fontFamily,
        fontSize: "1rem",
        fontFeatureSettings: "'tnum' 1"
    },
    body2: {
        fontFamily,
        fontSize: "0.875rem",
        fontFeatureSettings: "'tnum' 1"
    },
    caption: {
        fontFamily,
        fontSize: "0.75rem",
        fontFeatureSettings: "'tnum' 1"
    },
    overline: {
        fontFamily,
        fontSize: "0.625rem",
        textTransform: "none",
        fontFeatureSettings: "'tnum' 1"
    },
    subtitle1: {
        fontFamily,
        fontSize: "1rem",
        fontFeatureSettings: "'tnum' 1"
    },
    subtitle2: {
        fontFamily,
        fontSize: "0.875rem",
        fontFeatureSettings: "'tnum' 1"
    },
    buttonLarge: {
        fontFamily,
        fontSize: 16,
        lineHeight: "24px",
        textTransform: "none",
        fontFeatureSettings: "'tnum' 1"
    },
    buttonMedium: {
        fontFamily,
        fontSize: 16,
        lineHeight: "24px",
        textTransform: "none",
        fontFeatureSettings: "'tnum' 1"
    },
    buttonSmall: {
        fontFamily,
        fontSize: 14,
        lineHeight: "20px",
        textTransform: "none",
        fontFeatureSettings: "'tnum' 1"
    }
};
export default Typography;

//# sourceMappingURL=index.js.map